module.exports = __webpack_public_path__ + "static/mockingbot.35bb810a.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/examples/thumbnails/mockingbot.png
// module id = 852
// module chunks = 73261030922168